/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Box,
  RadioGroup,
  FormControlLabel,
  FormControl,
  InputLabel,
  IconButton,
  Radio,
  Typography,
  Divider,
  FormHelperText,
  Autocomplete,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import API from "../../Utils/Interceptor/ApiMiddleware";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import QuillEditor from "./QuillEditor";
import CustomSnackbar from "./CustomSnackBarMenu";

const AddCompanyModal = ({
  open,
  handleClose,
  companyId,
  branchId,
  branchDetails,
  companyDetails,
  fetchCompaniesGridData
}) => {
  const [tab, setTab] = useState(0);
  const [formState, setFormState] = useState({
    selectedEmployer: "",
    selectedState: "",
    selectedCity: "",
    selectedZipcode: "",
    companyName: "",
    companyWebsite: "",
    phone: "",
    address: "",
    selectedFile: null,
    logoPath: "",
    logoName: "",
    description: "",
    isBranchManaged: 0,
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [apiData, setApiData] = useState({
    employersName: [],
    statesData: [],
    citiesData: [],
    zipcodesData: [],
  });
  const [fetchedCitiesStates, setFetchedCitiesStates] = useState({});
  const [fetchedZipCities, setFetchedZipCities] = useState({});

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [errors, setErrors] = useState({});

  const handleTabChange = (event, newValue) => {
    if (newValue === 1 && !validateForm(1)) {
      return;
    }
    setTab(newValue);
  };
  const handleNext = () => {
    if (validateForm(1)) {
      setTab(1);
    }
  };

  const validateForm = (activeTab) => {
    const newErrors = {};
    const numericPart = (formState.phone || "")
      .replace("+1 ", "")
      .replace(/\s/g, "");

    if (branchId === 0 || branchId || activeTab === 1) {
      if (!formState.companyName) {
        newErrors.companyName =
          branchId || branchId === 0
            ? "Branch name is required"
            : "Company name is required";
      }

      if (!formState.phone) newErrors.phone = "Phone number is required";

      if (numericPart.length !== 10) {
        newErrors.phone = "It should contain exactly 10 digits.";
      }

      if (branchId !== 0 && !branchId && !formState.selectedEmployer)
        newErrors.selectedEmployer = "Employer name is required";
      if (
        branchId !== 0 &&
        !branchId &&
        !formState.selectedFile &&
        !formState.logoPath
      ) {
        newErrors.selectedFile = "File is required";
      }
    }

    if (branchId === 0 || branchId || activeTab === 2) {
      if (!formState.address) newErrors.address = "Address is required";

      if (!formState.selectedState)
        newErrors.selectedState = "State is required";

      if (!formState.selectedCity) newErrors.selectedCity = "City is required";

      if (!formState.selectedZipcode)
        newErrors.selectedZipcode = "Zipcode is required";

      // if (!formState.description)
      //   newErrors.description = "Description is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddCompany = async () => {
    const isTab1Valid = validateForm(1);
    const isTab2Valid = validateForm(2);

    if (!isTab1Valid || !isTab2Valid) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append("employer_name", formState.selectedEmployer);
      formData.append("name", formState.companyName);
      formData.append("addressLine1", formState.address);
      formData.append("city", formState.selectedCity);
      formData.append("state", formState.selectedState);
      formData.append("zip", formState.selectedZipcode);
      formData.append("phone", formState.phone.replace("+1 ", ""));
      formData.append("url", formState.companyWebsite);
      formData.append("notes", formState.description);
      formData.append("is_branch_managed", formState.isBranchManaged);
      formData.append("logo", formState.selectedFile);
      formData.append("emp_id", localStorage.getItem("empId"));
      formData.append("user_id", formState.user_id);

      await API.post("/company/create-company", formData);

      setSnackbar({
        open: true,
        message: "Company added successfully",
        severity: "success",
      });

      setTimeout(() => {
        handleClose();
        // window.location.reload();
        fetchCompaniesGridData();
      }, 2000);
    } catch (error) {
      console.error("Error adding company:", error);

      const errorMessage =
        error.response?.data?.message || "Failed to add company";
      setSnackbar({
        open: true,
        message: errorMessage,
        severity: "error",
      });
    }
  };

  const handleUpdate = async () => {
    if (companyId) {
      if (!validateForm(1) || !validateForm(2)) {
        return;
      }
      try {
        const formData = new FormData();

        formData.append("name", formState.companyName);
        formData.append("addressLine1", formState.address);
        formData.append("city", formState.selectedCity);
        formData.append("state", formState.selectedState);
        formData.append("zip", formState.selectedZipcode);
        formData.append("phone", formState.phone.replace("+1 ", ""));
        formData.append("url", formState.companyWebsite);
        formData.append("notes", formState.description);
        formData.append(
          "logo",
          formState.selectedFile ? formState.selectedFile : formState.logoPath
        );
        formData.append("isBranchManaged", formState.isBranchManaged);

        const response = await API.post(
          `/company/update-company/${companyId}`,
          formData
        );
        setSnackbar({
          open: true,
          message: response?.data?.data?.msg,
          severity: "success",
        });

        setTimeout(() => {
          handleClose();
          window.location.reload();
        }, 2000);
      } catch (error) {
        console.error("Error updating company:", error);

        const errorMessage =
          error.response?.data?.message || "Failed to update company";
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: "error",
        });
      }
    } else if (branchId) {
      const isValid = validateForm();
      if (!isValid) return;
      try {
        const payload = {
          name: formState.companyName,
          phone: formState.phone,
          addressLine1: formState.address,
          city: formState.selectedCity,
          state: formState.selectedState,
          zip: formState.selectedZipcode,
          notes: formState.description,
        };

        await API.post(`/company/update-branch/${branchId}`, payload);
        setSnackbar({
          open: true,
          message: "Branch updated successfully",
          severity: "success",
        });

        setTimeout(() => {
          handleClose();
          window.location.reload();
        }, 2000);
      } catch (error) {
        console.error("Error updating branch:", error);
        const errorMessage =
          error.response?.data?.message || "Failed to update company";
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: "error",
        });
      }
    }
  };

  const fetchEmployerData = async () => {
    try {
      const response = await API.get("employer/get-employer-filter-details");
      setApiData((prevData) => ({
        ...prevData,
        employersName: response?.data?.data || [],
      }));
    } catch (error) {
      console.error("Error fetching employer data:", error);
    }
  };

  const fetchStatesData = async () => {
    try {
      const response = await API.post(
        process.env.REACT_APP_JOBEZEURL + "/state-city/list",
        {}
      );
      setApiData((prevData) => ({
        ...prevData,
        statesData: response?.data?.message || [],
      }));
    } catch (error) {
      console.error("Error fetching state-city data", error);
    }
  };

  const fetchCities = async (stateName) => {
    if (fetchedCitiesStates[stateName]) return;

    try {
      const response = await API.post(
        process.env.REACT_APP_JOBEZEURL + "/state-city/list",
        { stateName }
      );
      setApiData((prevData) => ({
        ...prevData,
        citiesData: response?.data?.message || [],
      }));
      setFetchedCitiesStates((prev) => ({ ...prev, [stateName]: true }));
    } catch (error) {
      console.error("Error fetching cities data", error);
    }
  };

  const fetchZipcodes = async ({ city }) => {
    if (fetchedZipCities[city]) return;

    try {
      const response = await API.post(
        process.env.REACT_APP_JOBEZEURL + "/state-city/list",
        { city }
      );
      setApiData((prevData) => ({
        ...prevData,
        zipcodesData: response?.data?.message || [],
      }));
      setFetchedZipCities((prev) => ({ ...prev, [city]: true }));
    } catch (error) {
      console.error("Error fetching zipcodes data", error);
    }
  };

  useEffect(() => {
    if (open) {
      fetchStatesData();
    }
  }, [open]);

  useEffect(() => {
    if (formState.selectedState) {
      fetchCities(formState.selectedState);
    }
  }, [formState.selectedState]);

  useEffect(() => {
    if (formState.selectedCity) {
      fetchZipcodes({ city: formState.selectedCity });
    }
  }, [formState.selectedCity]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "isBranchManaged" && value === "yes") {
      setDialogOpen(true);
      return;
    }
    setFormState((prevData) => {
      const updatedData = {
        ...prevData,
        [name]:
          name === "selectedZipcode"
            ? String(value)
            : name === "isBranchManaged"
            ? value === "yes"
              ? 1
              : 0
            : value,
      };

      if (name === "selectedState") {
        updatedData.selectedCity = "";
        updatedData.selectedZipcode = "";
        // fetchCities(value);
      } else if (name === "selectedCity") {
        updatedData.selectedZipcode = "";
        // fetchZipcodes({ city: value });
      }

      return updatedData;
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name],
    }));
  };

  const closeDialog = () => {
    setDialogOpen(false);
  };

  const handleOk = () => {
    setFormState((prevData) => ({
      ...prevData,
      isBranchManaged: 1,
    }));
    closeDialog();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    if (!(file.type === "image/png" || file.type === "image/jpeg")) {
      setSnackbar({
        open: true,
        message: "Please select a valid image file (JPEG, PNG, JPG).",
        severity: "error",
      });
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setSnackbar({
        open: true,
        message: "File should not exceed 5MB.",
        severity: "error",
      });
      return;
    }

    setFormState((prevState) => ({
      ...prevState,
      selectedFile: file,
      logoPath: "",
      logoName: "",
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedFile: undefined,
    }));

    setSnackbar({
      open: true,
      message: "File uploaded successfully",
      severity: "success",
    });
  };

  const handleAddBranch = async () => {
    const isValid = validateForm();
    if (!isValid) return;
    try {
      const payload = {
        companyId: companyId,
        name: formState.companyName,
        phone: formState.phone,
        addressLine1: formState.address,
        city: formState.selectedCity,
        state: formState.selectedState,
        zip: formState.selectedZipcode,
        notes: formState.description,
      };

      const response = await API.post(`/company/create-branch`, payload);

      if (response.status === 200) {
        setSnackbar({
          open: true,
          message: response?.data.data || "Branch added successfully",
          severity: "success",
        });

        setTimeout(() => {
          handleClose();
          window.location.reload();
        }, 2000);
      } else {
        setSnackbar({
          open: true,
          message: response?.data?.data || "Failed to add branch",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error adding branch:", error);
      const errorMessage =
        error.response?.data?.message || "Failed to add branch";
      setSnackbar({
        open: true,
        message: errorMessage,
        severity: "error",
      });
    }
  };

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      await fetchEmployerData();
      setFormState((prev) => ({
        ...prev,
        companyName: companyDetails.basicDetails.Name || "",
        companyWebsite: companyDetails.otherDetails.Website || "",
        phone: companyDetails.basicDetails["Contact Number"] || "",
        address: companyDetails.basicDetails.Address || "",
        selectedCity: companyDetails.basicDetails.City || "",
        selectedState: companyDetails.basicDetails.State || "",
        selectedZipcode: companyDetails.otherDetails.ZIP || "",
        selectedFile: null,
        logoPath: companyDetails.otherDetails.Logo || "",
        logoName: companyDetails.otherDetails["Logo Name"] || "",
        description: companyDetails.basicDetails["Additional Info"] || "",
        selectedEmployer: companyDetails.otherDetails.Owner || "",
        isBranchManaged: companyDetails.otherDetails["Is Branch Managed"] || 0,
      }));
    };

    if (open) {
      if (companyId && branchId !== 0) {
        fetchCompanyDetails();
      } else if (branchId && branchDetails) {
        setFormState((prev) => ({
          ...prev,
          companyName: branchDetails.basicDetails?.Name || "",
          address: branchDetails.basicDetails?.Address || "",
          phone: branchDetails.basicDetails?.["Contact Number"] || "",
          selectedCity: branchDetails.basicDetails?.City || "",
          selectedState: branchDetails.basicDetails?.State || "",
          selectedZipcode: branchDetails.otherDetails?.ZIP || "",
          description: branchDetails.basicDetails?.["Additional Info"] || "",
        }));
      }
    }
  }, [open, companyId, branchId, branchDetails]);

  return (
    <Dialog
      key={open ? "open" : "closed"}
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        handleClose();
      }}
      fullWidth
      disableBackdropClick
      disableEscapeKeyDown
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 3,
          overflow: "hidden",
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        padding={"0px 16px 0px 0px"}
      >
        <DialogTitle sx={{ fontSize: "22px", fontWeight: 500 }}>
          {branchId === 0
            ? "Add Branch"
            : branchId
            ? "Edit Branch"
            : companyId
            ? "Edit Company"
            : "Add Company"}
        </DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "#F7F8FA",
          backgroundColor: "#F7F8FA",
          padding: "10px 24px 0px 24px",
        }}
      >
        {/* {!branchId && (
          <Tabs value={tab} onChange={handleTabChange} variant="fullWidth">
            <Tab label="Basic Info" sx={{ flex: 1 }} />
            <Tab label="Additional Info" sx={{ flex: 1 }} />
          </Tabs>
        )} */}
        {branchId === 0 || branchId ? (
          <Tabs value={tab} variant="fullWidth">
            <Tab label="Branch Info" sx={{ flex: 1 }} />
          </Tabs>
        ) : (
          <Tabs value={tab} onChange={handleTabChange} variant="fullWidth">
            <Tab label="Basic Info" sx={{ flex: 1 }} />
            <Tab label="Additional Info" sx={{ flex: 1 }} />
          </Tabs>
        )}
      </Box>

      <DialogContent sx={{ padding: "0px", height: "400px" }}>
        {/* 🔹 TAB 1 - Basic Info */}
        {tab === 0 && branchId !== 0 && !branchId && (
          <Box sx={{ mt: 2, padding: "0px 24px 20px" }}>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                paddingBottom: "10px",
              }}
            >
              Authority Details
            </Typography>
            <FormControl
              fullWidth
              error={!!errors.selectedEmployer}
              size="small"
              required
            >
              <Autocomplete
                options={apiData.employersName}
                getOptionLabel={(option) => option.name}
                value={
                  apiData.employersName.find(
                    (emp) => emp.user_id === formState.selectedEmployer
                  ) || null
                }
                onFocus={() => {
                  if (!apiData.employersName.length) fetchEmployerData();
                }}
                onChange={(event, newValue) => {
                  if (!!companyId) return;
                  handleInputChange({
                    target: {
                      name: "selectedEmployer",
                      value: newValue ? newValue.user_id : "",
                    },
                  });
                  handleInputChange({
                    target: {
                      name: "user_id",
                      value: newValue ? newValue.user_id : "",
                    },
                  });
                }}
                disabled={!!companyId}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Employer"
                    variant="outlined"
                    required
                    error={!!errors.selectedEmployer}
                    helperText={errors.selectedEmployer}
                    size="small"
                  />
                )}
              />
            </FormControl>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                paddingTop: "15px",
                paddingBottom: "10px",
              }}
            >
              Company Details
            </Typography>

            <Box display="flex" flexDirection="column" gap={1}>
              <Box display="flex" gap={2} alignItems="center">
                <Box
                  component="label"
                  sx={{
                    height: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    padding: "10px",
                    width: "100%",
                    border: !!errors.selectedFile
                      ? "1px solid red"
                      : "1px solid #ddd",
                    borderRadius: "4px",
                    bgcolor: "background.paper",
                  }}
                >
                  {formState.selectedFile || formState.logoPath ? (
                    <img
                      src={
                        formState.selectedFile
                          ? URL.createObjectURL(formState.selectedFile)
                          : `${process.env.REACT_APP_BASEURL}${formState.logoPath}`
                      }
                      alt="Logo Preview"
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "cover",
                        borderRadius: "4px",
                      }}
                    />
                  ) : (
                    <InsertDriveFileOutlinedIcon
                      sx={{ color: "#1976d2" }}
                      fontSize="small"
                    />
                  )}

                  <Typography color="#667085">
                    {formState.selectedFile
                      ? formState.selectedFile.name.length > 10
                        ? formState.selectedFile.name.substring(0, 10) + "..."
                        : formState.selectedFile.name
                      : formState.logoName
                      ? formState.logoName.length > 10
                        ? formState.logoName.substring(0, 10) + "..."
                        : formState.logoName
                      : "Your logo"}
                  </Typography>
                </Box>

                <Box
                  component="label"
                  sx={{
                    height: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    padding: "10px",
                    width: "100%",
                    cursor: "pointer",
                    borderRadius: "4px",
                    border: "1px solid #ddd",
                    bgcolor: "background.paper",
                  }}
                >
                  <FileUploadOutlinedIcon
                    sx={{ color: "#1976d2" }}
                    fontSize="small"
                  />
                  <Typography color="#667085">
                    {formState.selectedFile || formState.logoPath
                      ? "Replace Your Logo"
                      : "Upload Your Logo"}
                  </Typography>

                  <input
                    type="file"
                    hidden
                    onChange={handleFileChange}
                    accept="image/*"
                  />
                </Box>
              </Box>

              {errors.selectedFile && (
                <Typography color="error" variant="caption">
                  {errors.selectedFile}
                </Typography>
              )}
            </Box>

            <Box display="flex" gap={2} mt={2}>
              <TextField
                size="small"
                name="companyName"
                required
                onChange={handleInputChange}
                value={formState.companyName}
                fullWidth
                label="Company Name"
                error={!!errors.companyName}
                helperText={errors.companyName}
              />
              <TextField
                size="small"
                name="companyWebsite"
                onChange={handleInputChange}
                value={formState.companyWebsite}
                fullWidth
                label="Website"
              />
            </Box>
            <Box display="flex" gap={2} mt={2}>
              <TextField
                size="small"
                fullWidth
                label="Phone"
                name="phone"
                required
                onChange={(e) => {
                  let value = e.target.value;

                  if (!value.startsWith("+1 ")) {
                    value = "+1 ";
                  }
                  value = value.replace(/[^+\d\s]/g, "");
                  let numericPart = value.replace("+1 ", "").replace(/\s/g, "");
                  if (numericPart.length > 10) {
                    numericPart = numericPart.slice(0, 10);
                  }
                  handleInputChange({
                    target: { name: "phone", value: "+1 " + numericPart },
                  });
                }}
                value={formState.phone || "+1 "}
                error={!!errors.phone}
                helperText={errors.phone}
                inputProps={{ inputMode: "numeric" }}
                onKeyDown={(e) => {
                  if (
                    !/^\d$/.test(e.key) &&
                    e.key !== "Backspace" &&
                    e.key !== "Delete" &&
                    e.key !== "ArrowLeft" &&
                    e.key !== "ArrowRight"
                  ) {
                    e.preventDefault();
                  }
                  if (
                    (formState.phone || "+1 ") === "+1 " &&
                    e.key === "Backspace"
                  ) {
                    e.preventDefault();
                  }
                  let numericPart = formState.phone
                    .replace("+1 ", "")
                    .replace(/\s/g, "");
                  if (numericPart.length >= 10 && /^\d$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Box>
            <Box
              mt={2}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontSize: "17px" }}>
                Do you want to manage branches of this company?
              </Typography>
              <RadioGroup
                row
                name="isBranchManaged"
                value={formState.isBranchManaged ? "yes" : "no"}
                onChange={handleInputChange}
              >
                <FormControlLabel
                  value="yes"
                  control={<Radio disabled={formState.isBranchManaged === 1} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="no"
                  control={<Radio disabled={formState.isBranchManaged === 1} />}
                  label="No"
                />
              </RadioGroup>
            </Box>
            <Dialog
              open={dialogOpen}
              PaperProps={{
                sx: {
                  borderRadius: "20px",
                },
              }}
            >
              <DialogTitle sx={{ textAlign: "center", fontSize: "24px" }}>
                Do you want to manage <br /> branches for this Company?
              </DialogTitle>
              <DialogContent sx={{ textAlign: "center", pt: 1 }}>
                <Typography color="#ED6C02" fontSize="14px" mt={1}>
                  Once manage branch feature is enabled, it can't be disabled!
                </Typography>
              </DialogContent>
              <DialogActions sx={{ justifyContent: "center", pb: 2, gap: 2 }}>
                <Button variant="outlined" onClick={closeDialog}>
                  Cancel
                </Button>
                <Button variant="contained" onClick={handleOk}>
                  OK
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        )}

        {/* 🔹 TAB 2 - Additional Info */}
        {(tab === 1 || branchId || branchId === 0) && (
          <Box sx={{ mt: 2, padding: "0px 24px 24px" }}>
            {(branchId || branchId === 0) && (
              <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                <TextField
                  size="small"
                  name="companyName"
                  required
                  onChange={handleInputChange}
                  value={formState.companyName}
                  fullWidth
                  label="Branch Name"
                  error={!!errors.companyName}
                  helperText={errors.companyName}
                />

                <TextField
                  size="small"
                  fullWidth
                  label="Phone"
                  name="phone"
                  required
                  onChange={(e) => {
                    let value = e.target.value.startsWith("+1 ")
                      ? e.target.value
                      : "+1 ";

                    value = value.replace(/[^+\d\s]/g, "");
                    let numericPart = value
                      .replace("+1 ", "")
                      .replace(/\s/g, "");

                    if (numericPart.length > 10) {
                      numericPart = numericPart.slice(0, 10);
                    }

                    handleInputChange({
                      target: { name: "phone", value: "+1 " + numericPart },
                    });
                  }}
                  value={formState.phone || "+1 "}
                  error={!!errors.phone}
                  helperText={errors.phone}
                  inputProps={{ inputMode: "numeric" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                    ];
                    const numericPart = (formState.phone || "+1 ")
                      .replace("+1 ", "")
                      .replace(/\s/g, "");

                    if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
                      e.preventDefault();
                    }

                    if (
                      (formState.phone || "+1 ") === "+1 " &&
                      e.key === "Backspace"
                    ) {
                      e.preventDefault();
                    }

                    if (numericPart.length >= 10 && /^\d$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Box>
            )}

            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                paddingBottom: "10px",
              }}
            >
              Address Details
            </Typography>
            <TextField
              size="small"
              fullWidth
              label="Write your address here....."
              name="address"
              onChange={handleInputChange}
              value={formState.address}
              error={!!errors.address}
              helperText={errors.address}
              sx={{ mb: 2 }}
              required
            />

            <Box display="flex" gap={2}>
              <FormControl
                size="small"
                fullWidth
                error={!!errors.selectedState}
                required
              >
                <InputLabel>Select State</InputLabel>
                <Select
                  label="Select State"
                  name="selectedState"
                  value={formState.selectedState}
                  // onFocus={fetchStatesData}
                  onChange={handleInputChange}
                >
                  {apiData.statesData.map((state) => (
                    <MenuItem key={state.name} value={state.name}>
                      {state.name}
                    </MenuItem>
                  ))}
                </Select>
                {errors.selectedState && (
                  <FormHelperText>{errors.selectedState}</FormHelperText>
                )}
              </FormControl>

              <FormControl
                size="small"
                fullWidth
                disabled={!formState.selectedState}
                error={!!errors.selectedCity}
                required
              >
                <InputLabel>Select City</InputLabel>
                <Select
                  label="Select City"
                  name="selectedCity"
                  value={formState.selectedCity}
                  onFocus={() => fetchCities(formState.selectedState)}
                  onChange={handleInputChange}
                >
                  {apiData.citiesData.map((city) => (
                    <MenuItem key={city.city} value={city.city}>
                      {city.city}
                    </MenuItem>
                  ))}
                </Select>
                {errors.selectedCity && (
                  <FormHelperText>{errors.selectedCity}</FormHelperText>
                )}
              </FormControl>

              <FormControl
                size="small"
                fullWidth
                disabled={!formState.selectedCity}
                error={!!errors.selectedZipcode}
                required
              >
                <InputLabel>Select Zipcode</InputLabel>
                <Select
                  label="Select Zipcode"
                  name="selectedZipcode"
                  value={formState.selectedZipcode}
                  onFocus={() =>
                    fetchZipcodes({ city: formState.selectedCity })
                  }
                  onChange={handleInputChange}
                >
                  {apiData.zipcodesData.map((zipcode) => (
                    <MenuItem key={zipcode.zip} value={zipcode.zip}>
                      {zipcode.zip}
                    </MenuItem>
                  ))}
                </Select>
                {errors.selectedZipcode && (
                  <FormHelperText>{errors.selectedZipcode}</FormHelperText>
                )}
              </FormControl>
            </Box>

            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                paddingTop: "15px",
              }}
            >
              Brief Description
            </Typography>

            <Box mt={2}>
              {/* {errors.description && (
                <Typography color="error" variant="caption">
                  {errors.description}
                </Typography>
              )} */}
              <QuillEditor
                value={formState.description}
                onChange={(value) =>
                  handleInputChange({ target: { name: "description", value } })
                }
              />
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          width: "100%",
          padding: "16px 24px",
          borderTop: "1px solid rgba(0, 0, 0, 0.10)",
        }}
      >
        {branchId ? (
          <>
            <Button
              onClick={handleClose}
              variant="outlined"
              sx={{ flex: 1, textTransform: "none", padding: "10px" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{ flex: 1, textTransform: "none", padding: "10px" }}
              onClick={handleUpdate}
            >
              Update
            </Button>
          </>
        ) : (
          <>
            <Button
              onClick={tab === 0 ? handleClose : () => setTab(0)}
              variant="outlined"
              sx={{ flex: 1, textTransform: "none", padding: "10px" }}
            >
              {tab === 0 ? "Cancel" : "Back"}
            </Button>
            <Button
              variant="contained"
              sx={{ flex: 1, textTransform: "none", padding: "10px" }}
              onClick={
                branchId === 0
                  ? handleAddBranch
                  : tab === 0
                  ? handleNext
                  : companyId
                  ? handleUpdate
                  : handleAddCompany
              }
            >
              {branchId === 0
                ? "Add"
                : tab === 0
                ? "Next"
                : companyId
                ? "Update"
                : "Add"}
            </Button>
          </>
        )}
      </DialogActions>

      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </Dialog>
  );
};

export default AddCompanyModal;
